import { render, staticRenderFns } from "./DisplayMobiles.vue?vue&type=template&id=938fba48"
import script from "./DisplayMobiles.vue?vue&type=script&lang=js"
export * from "./DisplayMobiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports